/* FizzyIQ — RV bento (fizzy-rv-bento / rvbn-).
   Animates the "Did you know?" dot matrix: a lit pattern sweeps across the
   14×3 grid one column at a time, each column re-rolled randomly — a robotic,
   pixel-flashing readout. Runs only while the matrix is in view; respects
   reduced-motion (the static lit pattern stays) and pauses on hidden tabs. */
(function () {
  'use strict';

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COLS = 14;
  var ROWS = 5;
  var TICK_MS = 110;   // per-column step — ~1.5s per full sweep
  var LIT_RATE = 0.55; // share of dots lit when a column is re-rolled

  function initMatrix(matrix) {
    if (matrix.dataset.rvbnInit) return;
    matrix.dataset.rvbnInit = '1';
    if (REDUCE) return; // keep the resting pattern

    var dots = matrix.querySelectorAll('.rvbn-dot');
    if (!dots.length) return;

    var col = 0;
    var timer = 0;
    var playing = false; // true while the FIZZ easter egg is holding
    var inView = true;

    function step() {
      if (document.hidden || playing) return;
      for (var r = 0; r < ROWS; r++) {
        var d = dots[r * COLS + col];
        if (d) d.classList.toggle('is-lit', Math.random() < LIT_RATE);
      }
      col = (col + 1) % COLS;
    }

    function start() { if (!timer && !playing) timer = setInterval(step, TICK_MS); }
    function stop() { if (timer) { clearInterval(timer); timer = 0; } }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          inView = entries[i].isIntersecting;
          if (inView) start(); else stop();
        }
      }, { rootMargin: '120px 0px' });
      io.observe(matrix);
    } else {
      start();
    }

    /* Easter egg (Sam 2026-06-13): double-click the "Did you know?" card and the
       dots spell the brand name as an LED ticker. It opens reading "FIZZ" (the
       leading letters that fill the 14-col window), then the word scrolls left to
       reveal the full "FIZZYIQ" — F·I·Z·Z·Y·I·Q in a 3×5 dot font. After the
       scroll it holds, then the ambient flashing sweep resumes. Row-major: dot
       index = row*COLS + col; the 120ms opacity transition on .rvbn-dot smooths
       each frame so the scroll reads as the word moving across. */
    var GLYPH_W = 27; // full FIZZYIQ bitmap width (7 letters, 3px each + 1px gaps)
    var FIZZYIQ = [
      '111011101110111010101110111', /* row 0 */
      '100001000010001010100100101', /* row 1 */
      '111001000100010001000100101', /* row 2 */
      '100001001000100001000100111', /* row 3 */
      '100011101110111001001110001'  /* row 4 */
    ];
    function paintMarquee(offset) {
      for (var r = 0; r < ROWS; r++) {
        var rowBits = FIZZYIQ[r];
        for (var c = 0; c < COLS; c++) {
          var src = offset + c;
          var on = src < GLYPH_W && rowBits.charAt(src) === '1';
          var d = dots[r * COLS + c];
          if (d) d.classList.toggle('is-lit', on);
        }
      }
    }
    var eggTarget = matrix.closest('.rvbn-info') || matrix;
    eggTarget.addEventListener('dblclick', function () {
      if (playing) return;
      playing = true;
      stop();

      var MAX = GLYPH_W - COLS; // 13 — last offset that still fills the window
      var SCROLL = 120;         // ms per column step
      var HOLD_START = 750;     // ms reading the opening "FIZZ" before it scrolls
      var HOLD_END = 1600;      // ms on the final frame before the sweep resumes

      paintMarquee(0); /* opens reading FIZZ */

      for (var step = 1; step <= MAX; step++) {
        (function (s) {
          setTimeout(function () {
            if (!playing) return;
            paintMarquee(s);
          }, HOLD_START + (s - 1) * SCROLL);
        })(step);
      }

      setTimeout(function () {
        playing = false;
        if (inView) start();
      }, HOLD_START + MAX * SCROLL + HOLD_END);
    });
  }

  function initAll() {
    var nodes = document.querySelectorAll('.rvbn-matrix');
    for (var i = 0; i < nodes.length; i++) initMatrix(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ── the headline scroll paint ──────────────────────────────────────
     Drives one custom property, --paint (0→1); the per-character maths lives
     in CSS. Ported from fizzy-msn2-mission.js, minus its sticky-column branch:
     this heading does not pin, so progress is simply the section's approach
     through the viewport.

     Measured in DOCUMENT coordinates rather than from the heading's viewport
     rect, matching the mission driver — offsetTop keeps moving regardless of
     what any ancestor does, so nothing can freeze the paint mid-sentence.

     rAF-throttled, passive, and it writes only when the rounded value actually
     changes, so a scroll that does not move it costs nothing. */
  function initPaint() {
    var heads = document.querySelectorAll('[data-rvbn-paint]');
    if (!heads.length) return;
    if (REDUCE) return;   /* leave --paint at its fully-painted default */

    function docTop(el) {
      var y = 0;
      while (el) { y += el.offsetTop; el = el.offsetParent; }
      return y;
    }

    var items = [];
    Array.prototype.forEach.call(heads, function (h) {
      items.push({ el: h, last: -1 });
    });

    var START  = 0.80;   /* begin when the heading reaches 80% of the viewport */
    var TRAVEL = 0.45;   /* and finish 45% of a viewport later */
    var pending = false;

    function update() {
      pending = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var y  = window.pageYOffset || document.documentElement.scrollTop;
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        var top = docTop(it.el) - y;                       /* viewport-relative */
        var p = (vh * START - top) / (vh * TRAVEL);
        p = p < 0 ? 0 : (p > 1 ? 1 : p);
        var r = Math.round(p * 100) / 100;
        if (r !== it.last) { it.last = r; it.el.style.setProperty('--paint', r); }
      }
    }

    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    update();
  }

  initPaint();

  document.addEventListener('shopify:section:load', function (event) {
    var m = event.target && event.target.querySelector && event.target.querySelector('.rvbn-matrix');
    if (m) initMatrix(m);
    if (event.target && event.target.querySelector && event.target.querySelector('[data-rvbn-paint]')) initPaint();
  });
})();
